import React from 'react';
import { Instagram, Facebook } from 'lucide-react';

const TikTokIcon = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
    </svg>
);

const WhatsAppIcon = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/>
    </svg>
);

export const Footer = () => {
    return (
        <div className="w-full relative z-0">
            {/* Wave → dark footer */}
            <div className="relative z-10 -mb-1 w-full" style={{ lineHeight: 0, background: 'transparent' }}>
                <svg viewBox="0 0 1440 80" fill="none" xmlns="http://www.w3.org/2000/svg"
                    className="w-full" preserveAspectRatio="none" style={{ height: '60px' }}>
                    <path d="M0 0 C300 80 700 20 1100 60 C1270 75 1380 50 1440 40 L1440 80 L0 80 Z"
                        fill="#1a1a1a" />
                </svg>
            </div>

            {/* ══════════════════════════════════════
                FOOTER — Dark
            ══════════════════════════════════════ */}
            <footer className="relative z-10 w-full" style={{ background: '#1a1a1a' }}>
                <div className="max-w-lg mx-auto px-4 py-8 text-center">
                    {/* Contact numbers */}
                    <div className="rounded-2xl p-4 mb-4"
                        style={{ background: 'rgba(255,255,255,0.08)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)', border: '1px solid rgba(201,168,76,0.15)' }}>
                        <p className="text-white font-bold mb-1 cairo text-lg">ارقام التواصل</p>
                        <p className="font-black text-base cairo" style={{ color: '#C9A84C' }}>
                            01092929534 - 01559292436
                        </p>
                    </div>

                    {/* Technical support */}
                    <div className="rounded-2xl p-4 mb-6"
                        style={{ background: 'rgba(255,255,255,0.08)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)', border: '1px solid rgba(201,168,76,0.15)' }}>
                        <p className="text-white font-bold mb-1 cairo text-lg">الدعم الفني وشحن الاكواد</p>
                        <p className="font-black text-base cairo" style={{ color: '#C9A84C' }}>01559292436</p>
                    </div>

                    {/* Social icons */}
                    <div className="flex items-center justify-center gap-4 mb-6">
                        {/* Instagram */}
                        <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer"
                            className="w-14 h-14 rounded-2xl flex items-center justify-center text-white hover:-translate-y-1 transition-all hover:scale-110 shadow-lg"
                            style={{ background: 'radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%)' }}>
                            <Instagram size={28} />
                        </a>
                        {/* TikTok */}
                        <a href="https://www.tiktok.com/@mr.atfy_english" target="_blank" rel="noopener noreferrer"
                            className="w-14 h-14 rounded-2xl flex items-center justify-center text-white hover:-translate-y-1 transition-all hover:scale-110 shadow-lg"
                            style={{ background: '#000000' }}>
                            <TikTokIcon size={28} />
                        </a>
                        {/* Facebook */}
                        <a href="https://www.facebook.com/share/1BsdwQ4AG2/" target="_blank" rel="noopener noreferrer"
                            className="w-14 h-14 rounded-2xl flex items-center justify-center text-white hover:-translate-y-1 transition-all hover:scale-110 shadow-lg"
                            style={{ background: '#1877F2' }}>
                            <Facebook size={28} />
                        </a>
                        {/* WhatsApp */}
                        <a href="https://wa.me/201028608446" target="_blank" rel="noopener noreferrer"
                            className="w-14 h-14 rounded-2xl flex items-center justify-center text-white hover:-translate-y-1 transition-all hover:scale-110 shadow-lg"
                            style={{ background: '#25D366' }}>
                            <WhatsAppIcon size={28} />
                        </a>
                    </div>

                    {/* Motivational quote */}
                    <p className="text-white font-bold text-base mb-1 cairo">
                        ❤️ خليك ورا حلمك لحد ماتشوفوه عنيك ❤️
                    </p>
                    <p className="font-black text-lg cairo" style={{ color: '#C9A84C' }}>
                        محمد العاطفي
                    </p>

                    {/* Dev credits */}
                    <div className="border-t mt-6 pt-4 text-center" style={{ borderColor: 'rgba(255,255,255,0.08)' }}>
                        <span className="text-gray-600 text-xs block mb-1.5">Developed by</span>
                        <div className="flex flex-col items-center gap-1 text-sm font-mono font-black" dir="ltr">
                            <a href="https://wa.me/201064756266" target="_blank" rel="noopener noreferrer" className="dev-credits">
                                <span className="dev-credits-bracket">&lt;</span>Marwan Sami<span className="dev-credits-bracket">/&gt;</span>
                            </a>
                            <a href="https://wa.me/201028608446" target="_blank" rel="noopener noreferrer" className="dev-credits">
                                <span className="dev-credits-bracket">&lt;</span>Anas Hany<span className="dev-credits-bracket">/&gt;</span>
                            </a>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};
